import React, { memo, useState } from 'react';
import PropTypes from 'prop-types';
import { Stack, Typography, Chip } from 'investira.react.components';

const IMPACT_OPTIONS = [
  { id: 'ntr', value: null, label: 'N/A', color: 'primary.main' },
  { id: 'low', value: 0, label: 'Baixo', color: 'info.main' },
  { id: 'med', value: 1, label: 'Médio', color: 'warning.main' },
  { id: 'high', value: 2, label: 'Alto', color: 'error.main' }
];

const Impacto = memo(props => {
  const { defaultValue = null, onChange, label, variant = null, disabled = false } = props;

  const [value, setValue] = useState(defaultValue || null);
  const xSelectedValue = defaultValue || value;

  const handleSelect = pImpactId => {
    setValue(pImpactId);
    if (onChange) {
      onChange(pImpactId);
    }
  };

  if (disabled) {
    return null;
  }

  if (variant === 'readValue' && defaultValue === null) {
    return null;
  }

  return (
    <Stack spacing={1} direction="row" alignItems="center">
      <Typography
        variant="caption"
        color="textSecondary"
        sx={{ textTransform: 'uppercase', letterSpacing: 0.6 }}>
        {label}
      </Typography>
      <Stack
        direction="row"
        alignItems="center"
        sx={{
          //bgcolor: theme => theme.palette.action.hover,
          //borderRadius: 999,
          p: 0.1
        }}>
        {variant === 'readValue' && (
          <Typography
            variant="caption"
            color={`${IMPACT_OPTIONS[defaultValue].color}`}
            sx={{ textTransform: 'uppercase', letterSpacing: 0.6, fontWeight: 500 }}>
            {IMPACT_OPTIONS[defaultValue].label}
          </Typography>
        )}

        {(variant === 'default' || variant === null) &&
          IMPACT_OPTIONS.map((xOption, xIndex) => {
            const xIsSelected = xOption.value === xSelectedValue;
            const xColor = xOption.color;

            return (
              <Stack
                key={xOption.id}
                onClick={() => handleSelect(xOption.value)}
                justifyContent="center"
                alignItems="center"
                sx={{
                  flex: 1,
                  px: 2,
                  py: 0.1,
                  cursor: 'pointer',
                  borderRadius: 999,
                  bgcolor: xIsSelected ? xColor : 'transparent',
                  color: xIsSelected ? 'secondary.main' : 'primary.main',
                  fontWeight: xIsSelected ? 600 : 400,
                  transition: theme =>
                    theme.transitions.create(['background-color', 'color'], {
                      duration: theme.transitions.duration.shortest
                    })
                }}>
                <Typography variant="caption">{xOption.label}</Typography>
              </Stack>
            );
          })}
      </Stack>
    </Stack>
  );
});

Impacto.propTypes = {
  value: PropTypes.oneOf(['low', 'med', 'high']),
  onChange: PropTypes.func,
  label: PropTypes.string
};

export default Impacto;
